const complyStatus = [
    { label: 'Comply', value: 'Comply' },
    { label: 'Not Comply', value: 'Not Comply' }
];

export default complyStatus;
